import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";

const ResetPasswordModal = ({ t, showModal, loading, handleOk, handleModalClose }) => (
    <div>
        <div className="modal" style={{display: (showModal ? 'block': '')}}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t("staffManagement.resetPassword.title")}</h5>
                        <button type="button" className="close border-0" aria-label="Close" onClick={handleModalClose}>
                            <MdClose />
                        </button>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleModalClose}>{t("staffManagement.resetPassword.no")}</button>
                        <button type="button" disabled={loading} className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={handleOk}>
                            {t("staffManagement.resetPassword.yes")} {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-backdrop show"></div>
    </div>
);

export default ResetPasswordModal;